/**
 * Report actions
 */
export enum ReportActionEnum {
	/**
	 * Set report record status to 'active'
	 */
	ACTIVATE = 'activate',

	/**
	 * Set report record status to 'archived'
	 */
	ARCHIVE = 'archive',
}
